import { axios } from 'shared/axiosClient';
import { AxiosErrorHandler } from 'shared/Helpers';
import { VendorNoteData } from 'models/Note';
import { InquiryForm } from 'models/Inquiry';

/**
 * Update or delete note_reaction
 *
 * @param id
 * @param like
 */
export const upsertNoteReaction = async (id: number, like: boolean | null) => {
  try {
    const res = await axios.patch(`/api/note_reaction/${id}/reaction`, { like });
    if (res.data?.status === 'success') {
      return res.data.data;
    }
    return Promise.reject(Error(res.data.message));
  } catch (e) {
    AxiosErrorHandler(e);
  }
};

/**
 * Delete my note
 *
 * @param id
 */
export const deleteMyNote = async (id: number) => {
  try {
    const res = await axios.delete(`/api/note/${id}`);
    if (res.data?.status === 'success') {
      return res.data.data;
    }
    return Promise.reject(Error(res.data.message));
  } catch (e) {
    AxiosErrorHandler(e);
  }
};

/**
 * Insert note regarding a vendor
 *
 * @param vendor_id
 * @param data
 */
export const insertVendorNote = async (vendor_id: number, data: VendorNoteData) => {
  try {
    const res = await axios.post(`/api/vendor/${vendor_id}/note`, data);
    if (res.data?.status === 'success') {
      return res.data.data;
    }
    return Promise.reject(Error(res.data.message));
  } catch (e) {
    AxiosErrorHandler(e);
  }
};

/**
 * Insert note regarding a vendor
 *
 * @param vendor_id
 * @param parent_note_id
 * @param note
 * @param type
 */
export const insertVendorNoteReply = async (
  vendor_id: number,
  parent_note_id: number,
  note: string,
  type: 'peer' | 'analyst'
) => {
  try {
    const res = await axios.post(`/api/vendor/${vendor_id}/note/${parent_note_id}/reply`, { note, type });
    if (res.data?.status === 'success') {
      return res.data.data;
    }
    return Promise.reject(Error(res.data.message));
  } catch (e) {
    AxiosErrorHandler(e);
  }
};

/**
 * Insert Inquiry
 *
 * @param data
 */
export const insertInquiry = async (data: InquiryForm) => {
  try {
    const res = await axios.post(`/api/inquiry`, data);
    if (res.data?.status === 'success') {
      return res.data?.data;
    }
    return Promise.reject(Error(res.data?.message));
  } catch (e) {
    AxiosErrorHandler(e);
  }
};

/**
 * Select My Inquiries
 */
export const selectMyInquiries = async () => {
  try {
    const res = await axios.get(`/api/inquiries`);
    if (res.data?.status === 'success') {
      return res.data?.data;
    }
    return Promise.reject(new Error('No inquiries found'));
  } catch (e) {
    AxiosErrorHandler(e);
  }
};

/**
 * Select Inquiry
 *
 * @param id
 */
export const selectInquiry = async (id: number) => {
  try {
    const res = await axios.get(`/api/inquiries/${id}`);
    if (res.data?.status === 'success') {
      return res.data?.data;
    }
    return Promise.reject(Error(res.data?.message));
  } catch (e) {
    AxiosErrorHandler(e);
  }
};

/**
 * Insert inquiry reply to parent note
 *
 * @param parent_id
 * @param data
 */
export const insertInquiryReply = async (parent_id: number, data: { note: string; vendor_id?: number }) => {
  try {
    const res = await axios.post(`/api/inquiry/${parent_id}/reply`, data);
    if (res.data?.status === 'success') {
      return res.data?.data;
    }
    return Promise.reject(Error(res.data?.message));
  } catch (e) {
    AxiosErrorHandler(e);
  }
};
